"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function init() {}
var _default = init;
exports.default = _default;